export default __webpack_public_path__ + "static/media/SkybagsCardiff.3014199b.jpg";